import { AmbiguousUserProfile } from '@mint-lib/profile-helpers';

export const profile = {
  id: 0,
  email: '',
  role: 0,
  is_admin_user: true,
  profile: {
    id: 0,
    first_name: '',
    last_name: '',
    mobile_number: '',
    office_number: '',
    locale: 'en-GB',
    company: {
      id: 8,
      name: '',
      address_line_1: '',
      address_line_2: '',
      country: 'AL',
      city: '',
      state_province: '',
      post_zip_code: '',
      vat_number: '',
      currency: 'EUR',
      industries: [],
      logo: '',
      dashboard_url: '',
      session_timeout: 720,
      website: '',
      description: '',
      platform: null,
      license: '',
      controller_company: false,
      clients: [],
      controller_id: null,
      client_type: null,
      agency_company: false,
      agency_workspace_id: 0,
      idp_enabled: true,
      use_sso: true,
    },
    workspace: {
      id: 0,
      name: '',
      address_line_1: '',
      address_line_2: '',
      country: 'AL',
      city: '',
      state_province: '',
      post_zip_code: '',
      vat_number: '',
      currency: 'EUR',
      industries: [],
      logo: '',
      dashboard_url: '',
      session_timeout: 720,
      website: '',
      description: '',
      platform: null,
      license: '',
      controller_company: false,
      clients: [],
      controller_id: null,
      client_type: null,
      agency_company: false,
      agency_workspace_id: 0,
      idp_enabled: true,
      use_sso: true,
    },
    permissions: {},
    is_dummy_data: false,
    avatar: null,
    config: {
      google_map_api_key: '-',
      environment: '',
      demo_environment: false,
      mixpanel_token: '',
      tracker_proxy_url: '',
      intercom_hash: '',
    },
    formatting_config: {
      dates_format: null,
      numbers_format: null,
      currency_format: null,
    },
    organization_name: '',
  },
  is_owner: false,
  is_central_user: false,
  password_changed: '',
  io_group_id: null,
  ff_id: '',
  release: {
    number: '',
    available_versions: ['', ''],
    selected_version: '',
    notes: {
      v2: '',
      latest: '',
    },
  },
  custom_traits: [],
  department: '',
} as unknown as AmbiguousUserProfile;
